/**
 * Cascarón visual compartido de las páginas públicas de cuenta (login-like):
 * logo + título centrados y una tarjeta con el contenido. Mismo estilo que Login.
 */
export function AuthShell({ title, subtitle, children }: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-full items-center justify-center bg-slate-100 p-4 dark:bg-[#161616]">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center text-center">
          {/* 13-oct: el logo del negocio (el de su web), no el del sistema. */}
          <img src="/isologo-closecito.png" alt="El Closecito de Andrés" className="mb-4 h-20 w-20 rounded-full bg-white object-contain shadow-sm" />
          <h1 className="text-[26px] font-bold leading-8 tracking-[-0.01em] text-slate-900 dark:text-slate-100">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">{subtitle}</p>}
        </div>
        <div className="rounded-2xl bg-surface p-6 shadow-[0_0_0_0.5px_rgb(0_0_0/0.12),0_12px_32px_rgb(0_0_0/0.10)] dark:shadow-[0_0_0_0.5px_rgb(255_255_255/0.12),0_12px_32px_rgb(0_0_0/0.5)]">
          {children}
        </div>
      </div>
    </div>
  );
}
